export const isEmail = (email: string): boolean => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const match = emailRegex.test(email);

	return match;
};
